import { LogoutLink } from '../components/LogoutLink';

export const Logout = () => <LogoutLink />;
